import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { BTSport } from "../models/bt-sport";
import * as moment from "moment";
import { BTSportPossibleDatetime } from "../models/bt-sport-possible-datetime";

@Injectable()
export class BTSportService {
  constructor(private apiService: ApiService) {}

  /**
   * Get all TNT Sports Products
   */
  GetAllProducts() {
    return this.apiService.get("BTSport/Products").map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new BTSport(value));
      } else {
        return [];
      }
    });
  }

  /**
   * Get possible live date time
   */
  GetPossibleLiveDatetime(productCode: string) {
    return this.apiService
      .get("BTSport/Product/" + productCode + "/LiveDatetime")
      .map((res) => {
        if (res && res.value) {
          return new BTSportPossibleDatetime(res.value);
        }
      });
  }

  /**
   * Change sport of TNT Sports Product
   */
  UpdateBTSportSport(productCode: string, sportId: number, ageMarkId: number) {
    let body = {
      productCode: productCode,
      sportId: sportId,
      ageMarkId: ageMarkId
    };
    return this.apiService.post("BTSport/Sport", body).map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new BTSport(value));
      } else {
        return [];
      }
    });
  }

  /**
   * Change sporting event of TNT Sports Product
   */
  UpdateBTSportProduct(
    productCode: string,
    masterSportingEventId: number,
    sportingEventId: number,
    liveDate: Date,
    liveEnd: Date
  ) {
    let body = {
      productCode: productCode,
      masterSportingEventId: masterSportingEventId,
      sportingEventId: sportingEventId,
      liveDate: liveDate,
      liveEnd: liveEnd,
    };
    return this.apiService.post("BTSport/Product", body).map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new BTSport(value));
      } else {
        return [];
      }
    });
  }

  /**
   * Change type of TNT Sports Product
   */
  UpdateBTSportProductType(productCode: string, isSportingEvent: boolean) {
    let body = {
      productCode: productCode,
      isSportingEvent: isSportingEvent,
    };
    return this.apiService.post("BTSport/ProductType", body).map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new BTSport(value));
      } else {
        return [];
      }
    });
  }

  /**
   * Change sporting event of TNT Sports Product
   */
  UpdateBTSportNonSportiveClassification(
    productCode: string,
    typeId: number,
    groupId: number,
    labelId: number
  ) {
    let body = {
      productCode: productCode,
      typeId: typeId,
      groupId: groupId,
      labelId: labelId,
    };
    return this.apiService.post("BTSport/NonSportive", body).map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new BTSport(value));
      } else {
        return [];
      }
    });
  }

  /**
   * Fetch Master Sporting Event from chapca
   * @returns {Observable<any>}
   */
  GetMasterSportingEvents(sportId: number, liveDate: Date) {
    let body = {
      sportIds: [sportId],
      start: moment(liveDate, "DD/MM/YYYY hh:mm").format("YYYY-MM-DD"),
      end: moment(liveDate, "DD/MM/YYYY hh:mm")
        .add(1, "days")
        .format("YYYY-MM-DD"),
      status: ["5"],
    };
    return this.apiService
      .post("ExternalAPI/MasterSportingEvents/", JSON.stringify(body))
      .map((res) => {
        if (res && res.value) {
          return res.value;
        }
      });
  }

  /**
   * Fetch all Sporting Events from chapca by MasterSportingEvent Id
   * @returns {Observable<any>}
   */
  GetSportingEvents(sportingEventId: number, liveDate: Date) {
    let body = {
      sportingEventId: sportingEventId,
      start: moment(liveDate, "DD/MM/YYYY hh:mm").format("YYYY-MM-DD"),
      end: moment(liveDate, "DD/MM/YYYY hh:mm")
        .add(1, "days")
        .format("YYYY-MM-DD"),
    };
    return this.apiService
      .post("ExternalAPI/SportingEvents/", JSON.stringify(body))
      .map((res) => {
        if (res && res.value) {
          return res.value;
        }
      });
  }

  /**
   * Fetch all Age Marks
   * @returns {Observable<any>}
   */
  GetAgeMarks() {
    return this.apiService.get("ExternalAPI/AgeMarks/").map((res) => {
      if (res && res.value) {
        return res.value;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/bt-sport.service.ts